<template>
    <div class="main block">

        <base-spinner v-if="isLoading"></base-spinner>

        <div v-else-if="!activeSurvey" class="notification is-danger is-light">
            No active survey found.
        </div>

        <div v-else >
            <h6 class="title is-6 align-center">{{ activeSurvey.name }}</h6>
            <div class="field has-addons">
                <div class="control is-expanded block">
                    <input v-model="beneficiaryID" class="input" type="number" inputmode="numeric" />
                </div>
                <div class="control">
                    <button :disabled="!beneficiaryID" class="button is-info" @click="startSurvey">
                        Start Survey
                    </button>
                </div>
            </div>
        </div>
        
        <div class="notification" v-if="surveySuccessMessage">
            Survey Submitted Successfully!
        </div>
        <div v-if="!!error" class="notification is-danger is-light">
            <p>{{ error }}</p>
        </div>
    </div>

    <SurveyForm v-if="!error && showSurveyForm" @closeSurvey="closeSurvey" :id="this.activeSurvey.id" :beneficiaryID="Number(this.beneficiaryID)" ></SurveyForm>
    
</template>

<script>
import SurveyForm from '../../components/surveys/SurveyForm.vue';

export default {
    data() {
        return {
            beneficiaryID: null,
            error: null,
            isLoading: false,
            showSurveyForm: false,
            surveySuccessMessage: false
        }
    },
    computed: {
        surveys() {
            return this.$store.getters['surveys/getSurveys'];
        },
        activeSurvey() {
            return this.$store.getters['surveys/getActiveSurvey'];
        }
    },
    components: {
        SurveyForm,
    },
    created() {
        this.loadSurveys();
    },
    methods: {
        async startSurvey() {
            this.error = null;
            try {
                await this.$store.dispatch('beneficiary/checkIfBeneficiaryExists', this.beneficiaryID);
            } catch (error) {
                this.error = error.message || 'Something failed!';
            }
            this.showSurveyForm = true;
            this.surveySuccessMessage = false;
        },
        closeSurvey() {
            this.showSurveyForm = false;
            this.surveySuccessMessage = true;
            this.beneficiaryID = null;
        },
        async loadSurveys() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('surveys/fetchSurveys');
            } catch (error) {
                this.error = error.message || 'Something failed!';
            }
            this.isLoading = false;
        },
    }
}
</script>